import { isEqual, pick } from 'lodash';
import { ToolConfig } from '../model/flow.types';

const isToolEqual = (
  toolA: ToolConfig | Record<string, unknown>,
  toolB: ToolConfig
): boolean => {
  const equalityKeys: (keyof ToolConfig)[] = ['tcp', 'mass', 'cog', 'inertia'];
  const a = pick(toolA, equalityKeys);
  const b = pick(toolB, equalityKeys);

  return isEqual(a, b);
};

export { isToolEqual };
